// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.excel-table {
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
    table-layout: fixed;
}

.excel-table th,
.excel-table td {
    border: 1px solid #ddd;
    position: relative;
    overflow: hidden;
    white-space: nowrap;
    text-align: left;
    font-size: 11px;
    padding: 4px 6px;
}

/* Serial number column styling */
.excel-table td:nth-child(2) {
    text-align: center;
    font-weight: normal;
    background-color: inherit;
}

.excel-table th {
    background-color: #f3f3f3;
    font-weight: normal;
    -webkit-user-select: none;
            user-select: none;
    position: sticky;
    top: 0;
    z-index: 2;
    font-size: 11px;
}

.excel-table td:hover {
    background-color: #eef;
}

.excel-table input {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
    font-size: 11px;
}

.excel-table td,
.excel-table th {
    white-space: normal;
    word-break: break-word;
}

.resizer {
    position: absolute;
    top: 0;
    right: 0;
    width: 6px;
    height: 100%;
    cursor: col-resize;
    z-index: 1;
}

.header-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.header-content input {
    width: 100%;
    font-size: 12px;
    padding: 2px;
    border: 1px solid #ccc;
}

.highlight {
    background-color: #ffcccc;
}

.mandatory-empty {
    border: 2px solid red !important;
    background-color: #ffebee !important;
}

.mandatory-empty:hover {
    background-color: #ffcdd2 !important;
}

.facility-mismatch {
    border: 2px solid red !important;
    background-color: #ffebee !important;
}

.facility-mismatch:hover {
    background-color: #ffcdd2 !important;
}

.date-invalid {
    border: 2px solid red !important;
    background-color: #ffebee !important;
}

.date-invalid:hover {
    background-color: #ffcdd2 !important;
}

.loadgroup-error {
    border: 2px solid red !important;
    background-color: #ffebee !important;
}

.loadgroup-error:hover {
    background-color: #ffcdd2 !important;
}

.footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    background: white;
    z-index: 100;
    padding: 8px 0;
}

.buttonContainerFillTable {
    display: flex;
    gap: 4px;
    justify-content: flex-end;
    align-items: end;
}

.closeButton,
.clearButton,
.validateButton,
.uploadButton {
    flex: 0 0 auto;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/dcFileUpload/ExcelTable.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;IACzB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;;IAEI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA,iCAAiC;AACjC;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,OAAO;IACP,SAAS;IACT,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;;;IAII,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".excel-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-family: Arial, sans-serif;\n    table-layout: fixed;\n}\n\n.excel-table th,\n.excel-table td {\n    border: 1px solid #ddd;\n    position: relative;\n    overflow: hidden;\n    white-space: nowrap;\n    text-align: left;\n    font-size: 11px;\n    padding: 4px 6px;\n}\n\n/* Serial number column styling */\n.excel-table td:nth-child(2) {\n    text-align: center;\n    font-weight: normal;\n    background-color: inherit;\n}\n\n.excel-table th {\n    background-color: #f3f3f3;\n    font-weight: normal;\n    user-select: none;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    font-size: 11px;\n}\n\n.excel-table td:hover {\n    background-color: #eef;\n}\n\n.excel-table input {\n    width: 100%;\n    border: none;\n    outline: none;\n    background: transparent;\n    font-size: 11px;\n}\n\n.excel-table td,\n.excel-table th {\n    white-space: normal;\n    word-break: break-word;\n}\n\n.resizer {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 6px;\n    height: 100%;\n    cursor: col-resize;\n    z-index: 1;\n}\n\n.header-content {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.header-content input {\n    width: 100%;\n    font-size: 12px;\n    padding: 2px;\n    border: 1px solid #ccc;\n}\n\n.highlight {\n    background-color: #ffcccc;\n}\n\n.mandatory-empty {\n    border: 2px solid red !important;\n    background-color: #ffebee !important;\n}\n\n.mandatory-empty:hover {\n    background-color: #ffcdd2 !important;\n}\n\n.facility-mismatch {\n    border: 2px solid red !important;\n    background-color: #ffebee !important;\n}\n\n.facility-mismatch:hover {\n    background-color: #ffcdd2 !important;\n}\n\n.date-invalid {\n    border: 2px solid red !important;\n    background-color: #ffebee !important;\n}\n\n.date-invalid:hover {\n    background-color: #ffcdd2 !important;\n}\n\n.loadgroup-error {\n    border: 2px solid red !important;\n    background-color: #ffebee !important;\n}\n\n.loadgroup-error:hover {\n    background-color: #ffcdd2 !important;\n}\n\n.footer {\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    background: white;\n    z-index: 100;\n    padding: 8px 0;\n}\n\n.buttonContainerFillTable {\n    display: flex;\n    gap: 4px;\n    justify-content: flex-end;\n    align-items: end;\n}\n\n.closeButton,\n.clearButton,\n.validateButton,\n.uploadButton {\n    flex: 0 0 auto;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
